export * from './TypographyAlign';
export * from './TypographyBold';
export * from './TypographyColor';
export * from './TypographyTransform';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9vYmplY3RzL1R5cG9ncmFwaHkvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQTtBQUNqQyxjQUFjLGtCQUFrQixDQUFBO0FBQ2hDLGNBQWMsbUJBQW1CLENBQUE7QUFDakMsY0FBYyx1QkFBdUIsQ0FBQSJ9